import { useEffect, useState } from 'react';

/**
 * Detects navigator.onLine status and displays a persistent banner
 * when the user loses connectivity.
 *
 * Validates: Requirements 15.3
 */
export function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState<boolean>(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) {
    return null;
  }

  return (
    <div
      role="alert"
      aria-live="assertive"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: 'var(--color-danger)',
        color: 'var(--color-header-text)',
        padding: '0.75rem 1rem',
        textAlign: 'center',
        fontSize: '0.875rem',
        fontWeight: 500,
      }}
    >
      You are currently offline. Some features may be unavailable until connectivity is restored.
    </div>
  );
}
